module.exports = __webpack_public_path__ + "img/logomenu.df5e52d7.png";